export function isWebUsbSupported(): boolean {
  return "usb" in navigator && window.isSecureContext;
}
